"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var styled_system_1 = require("styled-system");
var Tag_pc_1 = require("./Tag.pc");
var colors_1 = require("./utils/colors");
/**
 * A text badge
 * https://www.figma.com/file/5otfo5aNKz5sgwGJZxCXrP/WIP-Pallet-DS2022?node-id=21%3A1287
 * @param {ReactComponent=} icon - React Component for an icon to be displayed next to the Pill
 */
var Tag = function (props) {
    var secondaryThemeColor = (0, colors_1.useSecondaryThemeColor)();
    return react_1.default.createElement(StyledTag, __assign({ secondaryThemeColor: secondaryThemeColor }, props));
};
exports.Tag = Tag;
var StyledTag = (0, styled_1.default)(Tag_pc_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    ", "\n    ", "\n    ", "\n\n    &.themed {\n      background: ", ";\n      color: ", ";\n    }\n  }\n"], ["\n  && {\n    ", "\n    ", "\n    ", "\n\n    &.themed {\n      background: ", ";\n      color: ", ";\n    }\n  }\n"])), styled_system_1.color, styled_system_1.layout, styled_system_1.space, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.primary;
}, function (_a) {
    var secondaryThemeColor = _a.secondaryThemeColor;
    return secondaryThemeColor;
});
var templateObject_1;
